import { render, staticRenderFns } from "./ComTable.vue?vue&type=template&id=9ec3e27c&scoped=true"
import script from "./ComTable.vue?vue&type=script&lang=js"
export * from "./ComTable.vue?vue&type=script&lang=js"
import style0 from "./ComTable.vue?vue&type=style&index=0&id=9ec3e27c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec3e27c",
  null
  
)

export default component.exports